import React from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { cn } from "../lib/utils";
import { Skeleton } from "./ui/skeleton";

export const KpiCard = ({
  label,
  value,
  hint,
  icon: Icon,
  tone = "neutral",
  delta,
  testId = "kpi-card",
  className,
}) => {
  const toneClass =
    tone === "profit" ? "text-[hsl(var(--profit))]" : tone === "loss" ? "text-destructive" : "";
  const DeltaIcon = delta != null && Number(delta) < 0 ? TrendingDown : TrendingUp;
  return (
    <div
      className={cn(
        "rounded-xl border border-border bg-card p-4 elev-1 transition-colors hover:border-primary/40",
        className
      )}
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        {Icon ? <Icon className="h-4 w-4 shrink-0 text-primary" /> : null}
      </div>
      <p
        className={cn("mt-2 font-num text-xl font-semibold sm:text-2xl", toneClass)}
        data-testid={`${testId}-value`}
      >
        {value}
      </p>
      {delta != null ? (
        <p
          className={cn(
            "mt-1.5 flex items-center gap-1 text-xs",
            Number(delta) < 0 ? "text-destructive" : "text-[hsl(var(--profit))]"
          )}
        >
          <DeltaIcon className="h-3 w-3" />
          {hint}
        </p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-muted-foreground">{hint}</p>
      ) : null}
    </div>
  );
};

export const KpiSkeleton = ({ count = 5 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-xl border border-border bg-card p-4">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="mt-3 h-7 w-28" />
        <Skeleton className="mt-3 h-3 w-16" />
      </div>
    ))}
  </>
);
